export default "__VITE_ASSET__QN50yd3___"